import { render } from "./index.vue?vue&type=template&id=976a2bf8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=976a2bf8&scoped=true&lang=css"

import exportComponent from "D:\\exploitation\\Apache24\\htdocs\\fwsy1\\node_modules\\.store\\vue-loader@17.0.1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-976a2bf8"]])

export default __exports__